export default __webpack_public_path__ + "images/rosabandet/menu-ribbon.png";